/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Readd_BtnInputs */



/**
* | output |
* | --- |
* | "Re-add Copilot" |
*
* @param {Sub_Addons_Confirm_Copilot_Readd_BtnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_readd_btn = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Readd_BtnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Readd_BtnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Copilot erneut hinzufügen")
	return /** @type {LocalizedString} */ ("Re-add Copilot")
});